import { Component, OnInit, ViewChild, Input, EventEmitter } from '@angular/core';

import { Contact} from 'app/models/contact';
import { FormGroup } from '@angular/forms';
import { ContactService } from "app/services/contactService";
import { TagService } from 'app/services/tag.service';
import { Tag } from 'app/models/tag';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss']
})
export class ContactFormComponent implements OnInit {

  @Input() isInsideModal: boolean = false;

  isNgSelectLoading: boolean = false;

  _currentContact: Contact = null;
  @Input() set currentContact (contact: Contact) {
      if (contact !== null)
        this.contactForm.patchValue(contact);
      else
        this.contactForm.reset();

      this._currentContact = contact;
  }

  get currentContact() : Contact {
    return this._currentContact;
  }
  
  getValue() {
    return this.contactForm.value as Contact;
  }

  getFormGroup() {
    return this.contactForm;
  }
  contactForm: FormGroup;
  @Input() tags: Tag[] = [];

  constructor(private contactService: ContactService, public tagService: TagService) { 
    this.contactForm = this.contactService.formGroup();
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }
  ngOnInit() {
  }

  innerWidth() {
    return window.innerWidth;
  } 
}
